// src/pages/Presidente/NomearPresidentePage.jsx
import React from 'react';
import PresidenteForm from '../../components/Presidente/PresidenteForm';

const NomearPresidentePage = () => {
    return (
        <div>
            <h1>Nomear Presidente</h1>
            <PresidenteForm onSuccess={() => alert('Presidente nomeado com sucesso!')} />
        </div>
    );
};

export default NomearPresidentePage;
